// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__image-load-hlO1a {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sunzi__image-load-hlO1a img {
  max-width: 100%;
  max-height: 100%;
}
.sunzi__image-load-hlO1a .sunzi__ripple-RRM99 {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  margin: auto;
  border-radius: 50%;
  background: var(--sunzi-theme-color);
  animation: sunzi__ripple-RRM99 1s 0s ease-in-out infinite;
}
.sunzi__image-load-hlO1a .sunzi__ripple-hide-dLc_I {
  display: none;
}
@keyframes sunzi__ripple-RRM99 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageLoad/style.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAPA;EAQI,eAAA;EACA,gBAAA;AAEJ;AAXA;EAYI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,yDAAA;AAEJ;AAxBA;EAyBI,aAAA;AAEJ;AAEA;EACE;IACE,mBAAA;EAAF;EAEA;IACE,mBAAA;IACA,UAAA;EAAF;AACF","sourcesContent":[".image-load {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  img {\n    max-width: 100%;\n    max-height: 100%;\n  }\n  .ripple {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    margin: auto;\n    border-radius: 50%;\n    background: var(--sunzi-theme-color);\n    animation: ripple 1s 0s ease-in-out infinite;\n  }\n  .ripple-hide {\n    display: none;\n  }\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-load": `sunzi__image-load-hlO1a`,
	"imageLoad": `sunzi__image-load-hlO1a`,
	"ripple": `sunzi__ripple-RRM99`,
	"ripple-hide": `sunzi__ripple-hide-dLc_I`,
	"rippleHide": `sunzi__ripple-hide-dLc_I`
};
export default ___CSS_LOADER_EXPORT___;
